import {GET, POST} from '../../index'
// 获取所有banner
export const bannerAll = (data) => {
  return GET('/language/banner/all', data)
}

// 保存数据
export const bannerStore = (data) => {
  return POST('/language/banner/store', data)
}

// 更新数据
export const bannerChange = (data) => {
  return POST('/language/banner/change', data)
}

// 删除数据
export const bannerDelete = (data) => {
  return POST('/language/banner/del', data)
}



// WEBPACK FOOTER //
// ./src/api/language/banner/index.js